module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-3",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("THREE")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("DC Hazel Hamilton had one ear tuned to the car’s police radio as she took notes of Luke’s version of the accident.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I heard the car before I saw it,’ said Luke. ‘I started to run before I thought about it.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She looked round at him, his face visible between the headrests, neutral and curious about everything going on around him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Despite his reassurances that he was fine, she knew all too well that sometimes people didn’t like to admit that they were feeling sick because of what they’d seen. She couldn’t completely rule out delayed shock or that for all his bravado he was suffering.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She waited with her biro poised above the page in her pocket notebook for Luke to continue.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I couldn’t be completely accurate, but I suppose he was doing about forty miles an hour,’ said Luke after a ten-or fifteen-second pause.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Even though Hazel now had her head down and was writing, she could see the man on the back seat of the car crane his neck towards the accident. It was natural for people to be curious, although rubberneckers always made her feel uneasy.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("At that moment, her train of thought was interrupted by a voice on the radio summoning all free and available patrols to make their way to an address, possible intruder on premises, woman lying injured. She had a feeling that she was listening to Major Crime being summoned to their next investigation.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The sound of her phone ringing from her pocket told her her instinct was right and she was about to get a whole lot busier.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To give herself some space and avoid being overheard, she climbed out of the car into the early morning heat and took a call from her former uniform inspector, Josh Walker. He was someone who had been a constant support to her before she’d returned to Major Crime. She listened intently, hardly uttered one word.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She ended the call and tapping the mobile phone into her empty hand glanced over her shoulder to the marked car, windows and doors shut, witness waiting for her return. She took in Luke as he sat impassive, watching her through the glass. He couldn’t possibly know that she had just been instructed to find someone else to take his statement, then go and change her clothes to avoid cross-contamination from the scene, before heading off to DI Bowman’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Inspector Walker’s last words to her had been, ‘Someone’s attacked his wife in their home. We think Milton did it.’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d6afc24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-003.vue
// module id = 81
// module chunks = 0